/**
 * slider using slickjs
 * @link https://kenwheeler.github.io/slick/
 */

jQuery(document).ready(function () {

	jQuery('.image-slider').slick({
		dots: false,
		arrows: false,
		infinite: true,
		draggable: false,
		pauseOnFocus: false,
		pauseOnHover: false,
		speed: 1500,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 6000,

	});

});


